const BottomArrow = (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="0.707107"
      y1="1.29289"
      x2="5.70711"
      y2="6.29289"
      stroke="#ABB2BF"
      stroke-width="2"
    />
    <line
      x1="4.29289"
      y1="6.29289"
      x2="9.29289"
      y2="1.29289"
      stroke="#ABB2BF"
      stroke-width="2"
    />
  </svg>
);

export default BottomArrow;